import { useState, useEffect } from 'react';
import type { CategoryKey } from '@common/constants/categories';

export const useCategoryImage = (category: CategoryKey) => {
  const [image, setImage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadImage = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // Dynamic import based on category
        const imageModule = await import(
          `../../../../../assets/media/banners/rts.${category.split('.')[1]}.jpg`
        );
        setImage(imageModule.default);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to load image'));
        // Fallback to women's fashion if there's an error
        const fallbackModule = await import('../../../../assets/media/banners/rts.womensFashion.jpg');
        setImage(fallbackModule.default);
      } finally {
        setIsLoading(false);
      }
    };

    void loadImage();
  }, [category]);

  return { image, isLoading, error };
};
